import styled from 'styled-components';

import { bokehTheme as bokeh } from '@vimeo/bokeh-theme';
import { Pop } from '@vimeo/iris/components';

export const PopDivider = styled(Pop.Divider)`
  border-color: ${({ theme }) =>
    theme.name === 'light' ? bokeh.colors.gray['100'] : bokeh.colors.gray['600']};
`;

export const PopItem = styled(Pop.Item)`
  font-size: 0.9rem;
  display: flex;
`;

export const Link = styled.a`
  text-decoration: none;
`;
